import React, { useState, useEffect } from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'

const testimonials = [
  {
    name: 'Amit Sharma',
    role: 'Operations Manager',
    date: '25 April, 2023',
    rating: 5,
    text: 'One of the best logistics experiences I’ve had. Timely and very professional.',
    avatar: 'A'
  },
  {
    name: 'Neha Verma',
    role: 'Founder, FreshMart',
    date: '12 March, 2024',
    rating: 4,
    text: 'Very responsive support team. Everything was smooth from pickup to delivery.',
    avatar: 'N'
  },
  {
    name: 'Ravi Patel',
    role: 'Supply Chain Head, MegaCorp',
    date: '8 Feb, 2024',
    rating: 5,
    text: 'Reliable shipping across regions. Real-time tracking worked perfectly.',
    avatar: 'R'
  }
]

export default function TestimonialSection () {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    const timer = setInterval(
      () => setIndex(prev => (prev + 1) % testimonials.length),
      4500 // smoother, professional pace
    )
    return () => clearInterval(timer)
  }, [])

  const t = testimonials[index]

  return (
    <section className='py-10 bg-[#f9f9f9]'>
      <div className='max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center'>
        {/* LEFT CONTENT */}
        <div>
          <h2 className='text-4xl font-extrabold text-[#1B1A4B] leading-tight'>
            Trusted by businesses
            <span className='block text-red-600'>across India</span>
          </h2>

          <p className='mt-6 text-lg text-gray-600 max-w-xl'>
            From first-mile pickup to last-mile delivery, S Infinite supports
            growing businesses with reliable, technology-driven logistics.
          </p>

          <div className='mt-8 flex items-center gap-4 text-sm text-gray-500'>
            <span>✔ Pan-India Network</span>
            <span>✔ 24×7 Support</span>
            <span>✔ On-Time SLA</span>
          </div>
        </div>

        {/* RIGHT CARD */}
        <div className='relative'>
          {/* Card */}
          <div className='bg-[#1B1A4B] rounded-2xl shadow-2xl p-8 md:p-10 transition-all duration-500'>
            {/* Rating */}
            <div className='flex mb-4'>
              {[...Array(t.rating)].map((_, i) => (
                <svg
                  key={i}
                  viewBox='0 0 24 24'
                  className='w-5 h-5 text-[#FFF44F]'
                  fill='currentColor'
                >
                  <path d='M12 .587l3.668 7.431 8.2 1.193-5.934 5.787 1.402 8.174L12 18.896l-7.336 3.86 1.402-8.174L.132 9.211l8.2-1.193z' />
                </svg>
              ))}
            </div>

            {/* Text */}
            <p className='text-white text-lg italic leading-relaxed mb-8'>
              “{t.text}”
            </p>

            {/* Author */}
            <div className='flex items-center gap-4'>
              <div className='w-12 h-12 rounded-full bg-[#FFF44F] text-[#1B1A4B] font-bold flex items-center justify-center'>
                {t.avatar}
              </div>
              <div>
                <p className='font-semibold text-[#FFF44F]'>{t.name}</p>
                <p className='text-sm text-gray-300'>{t.role}</p>
              </div>
            </div>
          </div>

          {/* Controls */}
          <div className='flex justify-center gap-6 mt-8'>
            <button
              onClick={() =>
                setIndex(prev =>
                  prev === 0 ? testimonials.length - 1 : prev - 1
                )
              }
              className='p-3 rounded-full border border-gray-300 hover:bg-gray-200 transition'
            >
              <ChevronLeft />
            </button>
            <button
              onClick={() => setIndex(prev => (prev + 1) % testimonials.length)}
              className='p-3 rounded-full border border-gray-300 hover:bg-gray-200 transition'
            >
              <ChevronRight />
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
